import { makeGetRequest } from "../makeRequest";
import config from "../../config/app.config";

//const BASE_URL = `${config.apiUrl.nodeApiBaseUrl || "http://localhost:8080/nodeapi"}/channels`;
const BASE_URL = `${config.apiUrl.channels}`;
export const getChannels = async () => {
  try {
    const response = await makeGetRequest(BASE_URL);
    return response;
  } catch (error) {
    throw error;
  }
};
